// REACT
import React, { Component } from 'react';
// REDUX
import { connect } from 'react-redux';
import * as actions from '../../actions';

// REACT ROUTER
import { Link, withRouter } from 'react-router-dom';

// UTILS
import {constants} from '../../constants';

// CUSTOM COMPONENTS
import LoginDialog from '../Dialog/LoginDialog';

// STYLED COMPONENTS
import { StyledLogo } from '../StyledLogo';
import { StyledToolbar } from './StyledToolbar';
import { StyledToolbarContainer } from './StyledToolbarContainer';

import { StyledMediaQ } from '../StyledMediaQ';

import ToolbarOptions from './ToolbarOptions';
import { ShowWidth } from '../ShowWidth';
import { HideWidth } from '../HideWidth';
import TextButton from 'components/Button/TextButton';
import SearchIcon from 'material-ui/svg-icons/action/search';

/*

Props:
• screenWidth

*/

class ToolbarSearch extends Component {

	constructor(props) {
		super(props);
		this.state = { 
			height: '0',
			loginDialogOpen: false,
			menuAnchorElement: null,
			menuOpen: false,
			value: 1,
			width: '0', 
		};
		// this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
	}

	// componentDidMount() {
	// 	this.updateWindowDimensions();
	// 	window.addEventListener('resize', this.updateWindowDimensions);
	// }

	// componentWillUnmount() {
	// 	window.removeEventListener('resize', this.updateWindowDimensions);
	// }

	componentWillReceiveProps(nextProps) {
		// if (this.props.location !== nextProps.location) {
		// 	// console.log('LOCATION HAS CHANGED - UPDATING GLOBAL LOCATION STATE');
		// 	this.props.updateLocation(nextProps.location)
		// }
		// THIS GETS CLIENT DATA ON INITIAL LOGIN
		if (nextProps.userId !== this.props.userId && !!nextProps.userId) {
			nextProps.getClientData(nextProps.userId);
			// nextProps.getProviderUserData(nextProps.userId); // this probably does nothing TODO: DELETE IT
		}
	}

	// updateWindowDimensions() {
	// 	this.setState({ width: window.innerWidth, height: window.innerHeight });
	// 	this.props.updateWindowDimensions({ width: window.innerWidth, height: window.innerHeight });
	// 	// console.log(this.state.width, 'screen width')
	// }

	handleShowLogin = () => {
		// console.log('set dialog to open');
		this.setState({
			loginDialogOpen: true
		})
	}

	handleCloseLoginDialog = () => {
		this.setState({
			loginDialogOpen: false
		});
	}

	handleAccountMenuClick = (event) => {
		// This prevents ghost click.
		event.preventDefault();
	
		this.setState({
			menuAnchorElement: event.currentTarget,
			menuOpen: true,
		});
	};

	handleMenuClose = () => {
		this.setState({
			menuOpen: false
		})
	}

	toolbarOptionsColorSwitcher = () => {
		let color = ''
		if (this.state.width < constants.layout.breakpoint.break1 ){
			color = 'gray'
		}else {
			color = 'gray'
		}
		return color;
	}
	/*
		handleSearchIconClick = (event) => {
			if (event){
				event.preventDefault();
			}
			const { history } = this.props;
			// IF ROUTE IS **NOT** APP.JS
			if (history.location && history.location.pathname === `/search`){
				history.push(`/`)
				this.props.updateLocation(`/`);
				console.log('Going home...');
			} else {
				history.push(`/search`)
				this.props.updateLocation(`/search`);
				console.log('Going to search...');
			}
		}
	*/

	render = () => {
		const childNum = React.Children.count(this.props.children);
		
		let childrenMargin = null
		if (this.props.screenWidth < constants.layout.breakpoint.break1) { //TODO: update this to work with new constant break point
			childrenMargin = {marginLeft: 10}
		} else {
			childrenMargin = {marginLeft: 30}
		}
		return (
			<div ref="toolbar">
				{ this.props.showToolbar &&
				<StyledMediaQ
					defaultStyles={`	
						display: flex;
						justify-content: center;
						align-items: center;
						background-color: white;
						-webkit-box-shadow: -3px 6px 124px -33px rgba(0,0,0,0.7);
						-moz-box-shadow: -3px 6px 124px -33px rgba(0,0,0,0.7);
						box-shadow: -3px 6px 124px -33px rgba(0,0,0,0.7);
						border-bottom: rgba(0,0,0,0.14) 1px solid;
					`}
				>
				
					{ (!this.props.userId || this.state.loginDialogOpen) && 
						<LoginDialog
							modal={false}
							open={this.state.loginDialogOpen}
							handleClose={this.handleCloseLoginDialog}
						/>
					}

					<StyledToolbarContainer>
						<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
							<HideWidth width={constants.layout.breakpoint.break1}>
								<Link
									color={'rgba(255,255,255,0.8)'}
									// marginRight={60}
									to={'/'} 
									style={{ textDecoration: 'none' }}>
									<StyledLogo width={120} height={50}	
									// backgroundURL={'https://firebasestorage.googleapis.com/v0/b/cyno-5e3a9.appspot.com/o/CynoGraphics%2FCynoLogos%2FCyno_Logo_Wordmark-White.png?alt=media&token=8e68ee88-5e3a-4483-98b5-5928196c2218'}
								/>
								</Link>
							</HideWidth>
						
							<ShowWidth width={constants.layout.breakpoint.break1}>
								<Link
									color={'rgba(255,255,255,0.8)'}
									// marginRight={60}
									to={'/'} 
									style={{ textDecoration: 'none' }}>
									<StyledLogo width={50} height={50}	backgroundURL={'https://firebasestorage.googleapis.com/v0/b/cyno-5e3a9.appspot.com/o/CynoGraphics%2FCynoLogos%2FCyno_Logo_Colour.png?alt=media&token=26834d77-9aba-4f54-b90b-e4aa2c222f8a'}
								/>
								</Link>
							</ShowWidth>
							
							{/* Use this later to direct clients to marketplace
								<div style={childrenMargin}>
									<TextButton 
										onClick = {this.handleSearchIconClick}
										style={{color: 'gray'}}
									>
										<SearchIcon style={ styles.searchIconStyles } />
										{ (this.props.screenWidth > 600) && 
											'Find an Expert'
										}
									</TextButton>
								</div>
							 */}
							
						</div>

						<ToolbarOptions 
							mediaQ1 = { constants.layout.breakpoint.break1 } 
							color={ this.toolbarOptionsColorSwitcher() }
						/>
					</StyledToolbarContainer>
				</StyledMediaQ>
				}
			</div>
		);
	}
};

const mapStateToProps = ({auth, router, toolbar}) => ({
	location: router.location,
	userId: (auth.authData) ? auth.authData.id : null,
	showToolbar: toolbar.showToolbar
});

export const ToolbarSearchDisconnected = ToolbarSearch;

export default withRouter(connect(mapStateToProps, actions)(ToolbarSearch));

const styles = {
	searchIconStyles: {
		height: 35,
		width: 35,
		marginRight: 8,
		color: 'gray',
	}
}


// WEBPACK FOOTER //
// ./src/js/components/ToolbarSearch/ToolbarSearch.jsx